import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cps-guide-modal cover-background absolute w-full h-full top-0 left-0"
}
const _hoisted_2 = { class: "container flex flex-col relative" }
const _hoisted_3 = { class: "header flex mb-8 p-5" }
const _hoisted_4 = { class: "body overflow-hidden" }
const _hoisted_5 = { class: "content__container slider-content-background flex flex-col py-10 px-5" }
const _hoisted_6 = { class: "guide-title flex justify-center" }
const _hoisted_7 = { class: "mb-6 font-bold text-xl inline-block content-title-black mx-5" }
const _hoisted_8 = { class: "guide-img" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "slider-button-group absolute" }
const _hoisted_11 = { class: "slider-button-group__container flex" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isShowModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "close-icon ml-auto",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "slider-content__container w-full flex transition-transform duration-200 ease-out",
              style: _normalizeStyle(`transform: translateX(${_ctx.currentSelectedSliderIndex * -100}%)`)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guideContent, (content, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content",
                  key: index,
                  onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onTouchStart && _ctx.onTouchStart(...args))),
                  onTouchmove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onTouchMove && _ctx.onTouchMove(...args))),
                  onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onTouchEnd && _ctx.onTouchEnd(...args)))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("h3", _hoisted_7, _toDisplayString(content.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        class: "block w-full",
                        src: require(`../../assets/guide-images/${_ctx.locale}/${content.img}`),
                        alt: ""
                      }, null, 8, _hoisted_9)
                    ])
                  ])
                ], 32))
              }), 128))
            ], 4),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guideContent, (content, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["slider-button rounded-full w-2 h-2 mx-1 cursor-pointer slider-button-background", {isSelected: _ctx.currentSelectedSliderIndex === index}]),
                    key: index,
                    onClick: ($event: any) => (_ctx.clickMoveSlider(index))
                  }, null, 10, _hoisted_12))
                }), 128))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}